import GooglePlacesSearchController from './google_places_search_controller'

/**
 * Добавляет полю локации в поиске клубов автодополнение Google Places и
 * необязательное уточнение выдачи по геолокации браузера.
 *
 * Контроллер ждет пользовательское событие `google-maps:ready`, потому что
 * скрипт Google Maps загружается вне жизненного цикла Stimulus. Если
 * пользователь разрешил доступ к геолокации, полученные границы ненадолго
 * кешируются и используются, чтобы приблизить подсказки к текущему району.
 */
export default class ClubsSearchController extends GooglePlacesSearchController {
  get geoCacheKey() {
    return 'clubs_search_geo'
  }
}
